import _ from 'lodash';

export function afterUpdateDebounce(func: () => void) {
  return _.debounce(func, CONFIG.afterUpdateDebounceIntervalMilliseconds, {
    leading: true,
    trailing: true,
    maxWait: CONFIG.afterUpdateDebounceMaxWaitMilliseconds
  });
}

export function promiseWithResolvers<T>(): { promise: Promise<T>, resolve: (value: T | PromiseLike<T>) => void, reject: (reason?: any) => void} {
  let resolve, reject;
  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
}

/**
 * Call an async function with a maximum time limit (in milliseconds) for the timeout
 * @param {Promise<any>} asyncPromise An asynchronous promise to resolve
 * @param {number} timeLimit Time limit to attempt function in milliseconds
 * @returns {Promise<any> | undefined} Resolved promise for async function call, or an error if time limit reached
 */
export async function asyncCallWithTimeout<T>(asyncPromise: Promise<T>, timeLimit: number): Promise<T> {
  let timeoutHandle: number;

  const timeoutPromise = new Promise<T>((_resolve, reject) => {
      timeoutHandle = setTimeout(
          () => reject(new Error('Async call timeout limit reached')),
          timeLimit
      );
  });

  return Promise.race([asyncPromise, timeoutPromise]).then(result => {
      clearTimeout(timeoutHandle);
      return result;
  })
}
